/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Language';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const LanguageIcon = withMuiAdapter(Base, 'Language');
